import { render, staticRenderFns } from "./SystemSetting.vue?vue&type=template&id=91bbe32a&scoped=true&"
import script from "./SystemSetting.vue?vue&type=script&lang=ts&"
export * from "./SystemSetting.vue?vue&type=script&lang=ts&"
import style0 from "./SystemSetting.vue?vue&type=style&index=0&id=91bbe32a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bbe32a",
  null
  
)

export default component.exports